const stepReducer = (state = 1, { type, payload }:any) => {
    switch (type) {
        case 'SET_CURRENT_STEP':
            return payload
        default:
            return state
    }
}

export default stepReducer